<script setup>
const props = defineProps({
  activityIconName: String,
  activityIconClass: String,
});
const icon = `${props.activityIconClass} ${props.activityIconName}`;
</script>

<template>
  <font-awesome-icon :icon="icon"></font-awesome-icon>
</template>
